import React, {useState} from 'react'
import styled from 'styled-components';
import DocTable from '../common/DocTable'
import NoticeModel from './NoticeModel'

const ContentStyle = styled.div`
  h2 {
    color: #333333;
    margin: 30px 0;
  }
  .desc {
    color: #7D8A96;
    font-size: 15px;
    line-height: 26px;
    padding-bottom: 40px;
    border-bottom: 1px solid #AEB7C1;
  }
  h3 {
    color: #142A3F;
    margin-bottom: 20px;
  }
  .list-piece {
    line-height: 24px;
    font-size: 16px;
    color: #7D8A96;
    list-style: disc;
    margin-bottom: 40px;
    >li {
      margin-left: 20px;
      margin-bottom: 10px;
    }
    .sub-list {
      padding-left: 15px;
      list-style: decimal;
    }
  }
  .md-40 {
    margin-bottom: 40px;
  }
  .flex-j {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    h2 {
      margin: 20px 0;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const W33 = styled.div`
  width: 33.3%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function Content(props) {
  const tabledata = {
    titles: ['Hunter', 'fund', 'vote', 'bonus'],
    bodys: [
      ['1', '1', '√1', '1000*(1/6)'],
      ['2', '4', '√4', '1000*(2/6)'],
      ['3', '6', '√9', '1000*(3/6)'],
    ]
  }

  const [noticeModel, setNoticeModel] = useState(false);
  const hideNoticeModel = ()=> {
    setNoticeModel(false);
  }
  const showNoticeModel = (e)=> {
    e.preventDefault();
    setNoticeModel(true);
  }

  return (
    <ContentStyle>
      <NoticeModel
        show={noticeModel}
        onHide={hideNoticeModel}
        toSupportModel={props.toSupportModel}
      ></NoticeModel>
      
      <div className="flex-j">
        <W66>
          <h2 className="h2">Grant</h2>
          <div className="desc">
            <p>To expand the influence of Trias and call on more people to engage in the community, we are going to launch the 「<strong>TRIAS treasure hunting: Triasures Go</strong>」 Program.</p>
            <p>In building Trias, we find that some active triasurers have made great contributions to Trias by sharing our progress to friends, answering others' questions in the community, inspiring us to launch meaningful projects, so on and so forth. Your efforts are significant to build a promising Trias and we appreciate it. Therefore, the 「<strong>TRIAS treasure hunting: Triasures Go</strong>」 Program is designed to better support you. </p>
          </div>
        </W66>
        <W33>
          {props.children}
        </W33>
      </div>
      <W66>
        <h2 className="h2">Grant Details:</h2>
        <h3 className="h3">How to apply for the program?</h3>
        <ul className="list-piece">
          <li>The program has been launch on <a href="http://grant.trias.one/">Trias Grant.</a>  Anyone can apply for the program with 50 TRIAS staked. </li>
          <li>The deadline for application will be <strong>12:00 on June 4 (UTC),</strong> before which all Trias hunters should fill out an <a onClick={showNoticeModel} href="https://forms.gle/deog3mzKjmsGDSjU8">information form</a> so that we can make voting profiles for you. An e-mail linked with a google docx will be sent to you in 24 hours.</li>
          <li>Submitting the <a onClick={showNoticeModel} href="https://forms.gle/deog3mzKjmsGDSjU8">information form</a> and receiving our e-mail means you've applied for the program sucessfully and become a hunter. </li>
          <li>
            <div>Briefing speaking, there are 3 steps to apply for the program:</div>
            <ol className="sub-list">
              <li>Stake 50 TRIAS;</li>
              <li>Submit the information form</li>
              <li>Check the e-mail we send you</li>
            </ol>
          </li>
        </ul>

        <h3 className="h3">How to make contributions?</h3>
        <ul className="list-piece">
          <li>ll Trias hunters need to make contributions to the community and upload related screenshots to a link that will be sent to you after we receive your <a onClick={showNoticeModel} href="https://forms.gle/deog3mzKjmsGDSjU8">information form</a>. The deadline for uploading screenshots is <strong>12:00 on June 4 (UTC).</strong></li>
          <li>Contributions include anything to span the influence of Trias on the Internet like making Trias-related Youtube videos, answering questions in the community, creating posters about Trias, etc. </li>
          <li>Note that if no contribution has been made before allocation, the staked TRIAS won't be returned to you.</li>
        </ul>

        <h3 className="h3">What's the rule of voting:</h3>
        <ul className="list-piece">
          <li>Based on your contributions, the community would vote for you on our official website, so please get as many votes as possible by contributing more and calling on more people to vote.</li>
          <li>Hunters need to get at least ONE vote to be applicable for the rewards. Please be noted, hunters can vote for each other but not vote for him/herself.</li>
          <li>Each voter can only vote for one hunter once. Repetitive votes from one voter will only be counted as one vote.</li>
          <li>The voting will start at <strong>12:00 on May 22 (UTC) and ends at 12:00 on June 4 (UTC).</strong></li>
          {/* <li>To avoid cheating, every voter has to donate TRIAS when voting. The donation will be transferred to the hunter the voter votes for afterward. There's no limit on donations.</li> */}
        </ul>

        <h3 className="h3">How to allocate the bonus?</h3>
        <ul className="list-piece">
          <li>Trias will match 1000 TRIAS to reward hunters. Bonus will be allocated according to the voting result. </li>
          <li>If Hunter A gets 5 votes, and the total votes of all hunters are 100, he will get 5/100 of the rewards, which is 50 TRIAS.</li>
          {/* <li>For example, if there 3 Hunters involved, Hunter1 gets 1 TRIAS, Hunter2 gets 4 TRIAS, and Hunter3 gets 9 TRIAS, the number of their votes will be √ 1, √4, and √ 9, which equals 1, 2, and 3. To sum up, we have 6 votes in total, so the corresponding bonus will be 1000*(1/6), 1000*(2/6), and 1000*(3/6).</li>
          <li style={{listStyle: 'none'}}><DocTable {...tabledata} col={4}></DocTable></li>
          <li>Note：In the above situation, we suppose there is only one voter for each hunter. However, the real situation will be much more complicated with several voters who vote for several hunters. So, in practice, the system will calculate the fund of each voter according to Quadratic voting and count it into the final number of votes.</li> */}
        </ul>

        <h3 className="h3">How to become an ambassador?</h3>
        <ul className="list-piece">
          {/* <li>There are two rounds of the program, the first one starts on May 18, ends on June 4 and the second round starts on June 4 and ends on June 23.</li> */}
          <li>The top 20% of hunters in each round will automatically become candidates of Trias'  ambassadors, who can participate in deciding on core issues of Trias and get the NFT medal and Trias' souvenirs first. </li>
          {/* <li>And all candidates will compete for ambassadors afterward following similar rules as Trias Hunter Program, so don't cease making contributions even when you've finished your cycle. </li> */}
          <li>If you are interested in the details, please keep up with Trias' official account or the community.</li>
          <li>Just participate in the program with your family and friends! The more people participate, the more rewards you'll get!</li>
          <li><strong>Apply here: <a onClick={showNoticeModel} href="https://forms.gle/deog3mzKjmsGDSjU8">Application Form for 「TRIAS treasure hunting: Triasures Go」</a></strong></li>
        </ul>
      </W66>
      <W66>
        <h2 className="h2">Grant Guideline:</h2>
        <ul className="list-piece md-40">
          <li>Get TRIAS from exchanges and withdraw to your personal BSC wallet.</li>
          <li>Connect your personal wallet and donate TRIAS to grant for the hunters you support.</li>
          <li>No limitation on donation amount, nor on the number of hunters you support.</li>
          <li>Voting will start at <strong>12:00 on May 22 (UTC) and ends at 12:00 on June 4 (UTC).</strong></li>
        </ul>

      </W66>
    </ContentStyle>
  )
}
